<script setup>
  import Icon from '@/components/icons/Icon.vue';
</script>

<template>
  <div class="jwx-pro-forecast__message-block jwx-pro-forecast__out-of-season-block">
    <div class="jwx-pro-forecast__out-of-season-icon">
      <Icon name="pro-forecast" />
    </div>      
    <p class="jwx-pro-forecast__message-title" data-size="large">This forecast is currently<br>out of season.</p>
    <p class="jwx-pro-forecast__message-body" data-size="large">It will start again in the spring.</p>
  </div>
</template>